<template>
    <div>
        <!-- 图片 -->
        <div class="bg">
            <div class="sub-title">Honor</div>
            <!-- <div class="title">荣誉资质</div> -->
        </div>
        <div class="m-3">
            <div class="flex-row flex-wrap justify-center">
                <div class="flex-row flex-wrap justify-between">
                    <div @click="page('cases')" class="cases-item flex-column align-center justify-center"
                        :class="{ 'active': index == 0 }" v-for="(item, index) in honorSrc">
                        <!-- <img src="@/assets/img/honor/Cases.png" style="width: 100%;height: 100%;" alt=""> -->
                        <img :src="http.ipAddress+item.filePath" style="width: 100%;height: 100%;" alt="">
                        <div class="item-name">{{ item.name }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            honorSrc:[
                // {
                //     name:"",
                //     img:"荣誉资质-01.jpg",
                //     path:""
                // }
                // ,{
                //     name:"",
                //     img:"荣誉资质-02.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-03.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-04.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-05.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-06.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-07.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-08.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-09.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-10.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-11.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-12.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-13.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-14.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-15.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-16.jpg",
                //     path:""
                // }
            ]
        }
    },
    methods: {
        page() {
            this.$router.push('');
        }
    },
    mounted() {
            debugger
            let that=this;
            this.http.post("/api/FJ_Honor/GetAllHonor",JSON.stringify({})).then((result)=>{
                debugger
            let objResult= eval(result);
            let iCode= objResult.code;
            if(iCode==0){
                debugger
                that.honorSrc=objResult.data;
                }
            });
        }
}
</script>

<style scoped>
.bg {
    background: url('../../assets/img/honorbanner.jpg') no-repeat;
    background-size: 100% ;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}
.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}

.cases-item {
    width: 33.3%;
    padding: 10px;
    box-sizing: border-box;
    /* border: 1px solid #eee; */
}

.cases-item:nth-child(3n - 1) {
    border-left: none;
    border-right: none;
}
</style>


// WEBPACK FOOTER //
// src/views/honor/m_index.vue